<template>
    <div>
        <select v-model.trim="selSimple" :id="idSelect+'-select-simple'" class="custom-select custom-select-lg" placeholder="Consulta una opción" :disabled="disable">
            <option value="placeholder" disabled selected>Seleccione una opción</option>
            <option v-for="(opc, o) in options" :key="o">{{opc.text}}</option>
        </select>
        <!-- <pre>{{ options }}</pre> -->
        <!-- <pre>selSimple: {{ selSimple }}</pre> -->
        <!-- <pre>opcSeleccionado: {{ opcSeleccionado }}</pre> -->

    </div>
</template>
<script>
export default {
    props:{
        options: {
            type: Array,
            required: true,
        },
        disable:{
            type: Boolean,
            default: false
        },
        idSelect:{
            type: String,
            default: 'select'
        },
        valSecondSelSimple: {
            required: false,
            default: null,
        },
    },
    data(){
        return{
            selSimple: "placeholder",
            opcSeleccionado: null,
        }
    },
    methods:{
        selectSimple(){
            // console.log("Se selecciono lo siguiente", this.selSimple)
            if(this.selSimple != "placeholder"){
                let result = this.options.filter(item => item.value == this.selSimple || item.text.trim() == this.selSimple);
                this.opcSeleccionado = result[0]
                this.$emit("selectSimple", this.opcSeleccionado);
                // console.log("RESULT!!!!!!!!!!", this.opcSeleccionado)
            } else{
                this.opcSeleccionado = null;
            }
        }
    },
    watch:{
        selSimple(){
            this.selectSimple();
        },
        valSecondSelSimple(){
            this.selSimple = 'placeholder';
        }
    }
}
</script>